import { Link } from 'react-router-dom'

const FavoriteTractsTable = ({
    allTracts = [],
    favoriteTracts = [],
    deleteTractIsFavorite,
    setEditTract,
    setDeleteTract,
    showAddTract,
    showHideAddTract,
    showHideDelete,
}) => {
    
    return (
        
        <div
            className="mb-0 mr-4 FavoriteTractsTable "
            style={{ maxHeight: '220px', overflowY: 'scroll' }}>
            
            <div className="p-0 px-3 card-body" style={{ maxWidth: '99%' }}>
                
                {favoriteTracts?.map(favoriteTract => {
                    
                    const tract = allTracts?.find(it => it.id === favoriteTract.tractId)
                    
                    if (!tract) return null
                    
                    return (
                        
                        <div
                            key={`favorite-tract-${tract.id}`}
                            className="row"
                            style={{
                                border: '3px solid #243a59',
                                borderRadius: '8px',
                                backgroundColor: '#152e4d',
                                minHeight: '55px',
                            }}>
                            
                            <div className="mt-3 col-2" style={{ maxWidth: '120px' }}>
                                <Link to={`/tract/${tract.id}`}>{tract.name}</Link>
                            </div>
                            
                            <div className="mt-3 text-center col-3">
                                {tract.grossAcreage} Acres
                            </div>
                            
                            <div className="mt-1 col-3">
                                {(tract.assignedTo && tract.assignedTo.length > 1 && (
                                    <select
                                        className="pr-2 form-control select-box col"
                                        style={{ maxWidth: '150px' }}
                                        name="tract">
                                        {tract.assignedTo.map(assign => (
                                            <option key={assign.id} value={assign.firstName}>
                                                {assign.firstName}
                                            </option>
                                        ))}
                                    </select>
                                )) ||
                                    (tract.assignedTo &&
                                        tract.assignedTo.length === 1 &&
                                        tract.assignedTo[0].firstName) ||
                                    ''}
                            </div>
                            
                            <div className="mt-3 text-center col-2">
                                {tract.status}
                            </div>
                            
                            <div className="mt-3 text-right col-2">
                                <span
                                    className="fe fe-star-fill icon-mid col-10"
                                    onClick={() => {
                                        deleteTractIsFavorite(tract.id)
                                    }} />
                                <i
                                    className="mr-3 fe fe-edit-2 pointer-cursor"
                                    onClick={() => {
                                        setEditTract(tract)
                                        showHideAddTract(!showAddTract)
                                    }} />
                                <i
                                    className="fe fe-trash pointer-cursor"
                                    onClick={() => {
                                        setDeleteTract(tract)
                                        showHideDelete(true)
                                    }} />
                            </div>
                        
                        </div>
                        
                    )
                    
                })}
            
            </div>
        
        </div>
        
    )
    
}

export default FavoriteTractsTable
